import React, { useReducer, useEffect, useState } from "react"
import { getCountryCallingCode } from "react-phone-number-input"
import Layout from "../../../components/layout/layout"
import HowItWorks from "../../../components/cards/howitworks/HowItWorks"
import OurSolutions from "../../../components/solutions/Solutions"
import Clients from "../../../components/cards/clients"
import TestimonialSection from "../../../components/homepage/testimonials"
import Features from "../../../components/cards/features/Features"
import InquireSection from "../../../components/cards/inquire/InquireSection"
import OtherProducts from "../../../components/cards/relatedarticles/RelatedArticles"
import banner from "./banner.png"
import feature1 from "./feature-1.svg"
import feature2 from "./feature-2.svg"
import feature3 from "./feature-3.svg"
import feature4 from "./feature-4.svg"
import feature5 from "./feature-5.svg"
import {
  otherProducts,
  productFaq,
  formatNumber,
  validateEmail,
} from "../../../utils"
import SEO from "../../../components/seo"
import { requestService } from "../../../services"
import SucessModal from "../../../components/modals/successModal/successModal"
import BookingSection from "../../../components/serviceCards/bookingSection/index.jsx"

const ScoopX = ({ location: { pathname } }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company: "",
      comments: "",
      designation: "",
      country_code: "+1",
      requesting: false,
      response: "",
      terms: false,
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const data = {
    title:
      "Power up product \noutreach to the widest \ngroup of customers \nacross eCommerce sites.",
    bannerImage: banner,
    desc:
      "Enable product data syndication across multiple \necommerce sales platforms and marketplaces, \nwhile adhering to their protocols.",
    overview: "ScoopX Overview",
    overwiewList: [
      "Get customers to buy your product instead of the competing product on marketplace sites like Amazon?",
      "Do you want to allow omni-channel sales that enhances shopper experience?",
      "Do you want to prevent counterfeit sales by protecting your brand name?",
    ],
    overviewText:
      "The analytics tool is effective in combating competition and preventing customer churn to competitor sites/products. It helps drive your customer to your preferred sales channel. This helps them buy an authentic product, and not a copy or from another brand. Brand owners get the facility to sell the product across a broad set of sales channels, and manage them from a single platform, without having to toggle through multiple sites. Multiple providers will be selling the similar product in the retailer site. This can result in a price battle and the audience could end up buying your competitor products. The solution helps you outpace competition and enable the audience to be directed to the seller & site",
    features: [
      {
        title: "Sell more, sell \nsmart",
        description:
          "The AI-based solution helps improve the coverage of the genuine product on \ntrustworthy sales channels.",
        featureImage: feature1,
        imagePosition: "right",
      },
      {
        title: "One stop for managing all \nmarketplaces",
        description:
          "It facilitates effective yet easy single-window management of the product \nirrespective of the sales channel used to reach out to the customers",
        featureImage: feature2,
        imagePosition: "left",
      },
      {
        title: "Win audience attention \n& avoid churn",
        description:
          "Eliminate price war by keeping audience focused on your product at the \nseller’s site",
        featureImage: feature3,
        imagePosition: "right",
      },
      {
        title: "Prevent fraudulent \nselling",
        description:
          "Shoppers will be directed correctly so that they buy only genuine products and not fake or \ncopies sold under your brand name.",
        featureImage: feature4,
        imagePosition: "left",
      },
      {
        title: "Improve customer \nsatisfaction",
        description:
          "Elevates customer loyalty and drive long term retention to augment your \ntoplines.",
        featureImage: feature5,
        imagePosition: "right",
      },
    ],
    subSectionTitle: "Explore ScoopX",
    platformText:
      "The AI-based analytics solution directs your visitors straight to a trusted sales channel like your brand websites",
  }
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }
  const onCheck = e => {
    setDetails({ terms: e.target.checked })
  }
  const submit = async () => {
    setDetails({ submitted: true })
    const {
      name,
      phone,
      email,
      company,
      comments,
      designation,
      country_code,
      terms,
    } = details
    let data
    if (
      name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      comments !== "" &&
      designation !== "" &&
      validateEmail(email)
    ) {
      if (!terms) {
        alert("please accept our terms and conditions")
        return
      }
      let number = formatNumber(phone)
      data = {
        form_name: "contact form",
        page_url: pathname,
        section_name: "scoopx",
        name,
        company_name: company,
        designation,
        email,
        country_code,
        phone_number: number,
        your_message: comments,
      }
      try {
        setDetails({ requesting: true })
        let result = await requestService.productForm(data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company: "",
          comments: "",
          designation: "",
          country_code: "",
          requesting: false,
          terms: false,
          response: result && result.more_info,
          submitted: false,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Layout withBrand slidePosition={0} btnBg="#E65198" btnColor="#FFFFFF">
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <SEO
        title="Wersel ScoopX - Exceptional Capabilities for Powering eCommerce."
        keywords="wersel scoopx, brand analytics software, pricing intelligence software "
        description="Wersel scoopx enables product data syndication across multiple ecommerce sales platforms and marketplaces, while adhering to their protocols."
        url="www.wersel.io/products/scoopx"
      />
      <OurSolutions data={data} btnBg="#E65198" btnColor="#FFFFFF" />
      <Features title="ScoopX Features" features={data.features} />
      <BookingSection
        howItWorksTitle="ScoopX - Exceptional capabilities for powering eCommerce"
        howItWorks="See how your online retail business can augment toplines with this AI tool"
      />
      <Clients title="We gave solutions for" />
      <InquireSection
        withoutFaqText
        btnBg="#E65198"
        btnColor="#FFFFFF"
        faq={productFaq}
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
      {/* <TestimonialSection /> */}
      <OtherProducts path={pathname} title="Products" posts={otherProducts} />
    </Layout>
  )
}

export default ScoopX
